import React from 'react';

export enum MarketingTextType {
  BASIC = 'basic',
  OMIT = 'omit',
  LISTING = 'listing',
}

interface BaseRenderingOptions {
  marketingTextType: MarketingTextType;
  mainMarketingTitle?: React.ReactElement;
  marketingInfoList?: React.ReactElement[];
  cardMarketingTitle?: React.ReactElement;
  additionalMarketingContent?: React.ReactElement;
  hideCertifications?: boolean;
  skipSurvey?: boolean;
  successTitle?: string;
  successSubtitle?: React.ReactElement;
  awsAddPaymentLink?: React.ReactElement;
  showSalesAccessCheckbox?: boolean;
  showEmailAgreementCheckbox?: boolean;
  hideLoginLink?: boolean;
  pageNotFound?: boolean;
  skipRenderResources?: boolean;
  subtitleHeading?: React.ReactElement;
}

interface RenderingOptionsBasicMarketingText extends BaseRenderingOptions {
  marketingTextType: MarketingTextType.BASIC;
  mainMarketingTitle: React.ReactElement;
  marketingInfoList: React.ReactElement[];
  cardMarketingTitle: React.ReactElement;
}

interface RenderingOptionsOmitMarketingText extends BaseRenderingOptions {
  marketingTextType: MarketingTextType.OMIT;
}

interface RenderingOptionsListingMarketingText extends BaseRenderingOptions {
  marketingTextType: MarketingTextType.LISTING;
  cardMarketingTitle: React.ReactElement;
}

export type RenderingOptions =
  | RenderingOptionsBasicMarketingText
  | RenderingOptionsOmitMarketingText
  | RenderingOptionsListingMarketingText;
